const typeOverrides = {
  "noPersonalization-(No Personalization)": "playerName",
  colorZone1: "ColorZone1",
  colorZone2: "ColorZone2",
  "PentaGrip-(Add PentaGrip?)": "AddPentaGrip",
  "PentaGrip-(Remove PentaGrip?)": "RemovePentaGrip",

  // Goalie Stick
  "Shaft Color code": "ShaftColor",
  "Bauer Logo Color code": "BauerLogoColor",
  "Flylite Logo Color code": "FlyliteLogoColor",
  "Paddle Color code": "PaddleColor",
  "Outline Color code": "OutlineColor",
  "Shoulder Color code": "ShoulderColor",
  "Shoulder Decal Color code": "ShoulderDecalColor",
  "Spine Color code": "SpineColor",
  "Shoulder (aka Handle, paddle shape)": "Shoulder",
  "Logos Color code": "LogosColor",
};

const valueOverrides = {
  "noPersonalization-(No Personalization)": [
    { value: true, valueOverride: null },
    { value: false, valueOverride: "" },
  ],
};

export default function formatElementTypeAndValue({
  elementType,
  elementValue,
}) {
  const element_type =
    typeOverrides[elementType] ||
    elementType
      .replace(/\s+(.)/g, (_, char) => char.toUpperCase())
      .replace(/\s+/g, "");
  let element_value = elementValue;

  if (valueOverrides[elementType]) {
    const matchingValue = valueOverrides[elementType].find(
      (item) => item.value === elementValue
    );
    element_value = matchingValue ? matchingValue.valueOverride : elementValue;
  }

  return { element_type, element_value };
}
